var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationError = function SvgLocationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M3.126 14.779c0-6.559 5.317-11.875 11.876-11.875 6.543 0 11.85 5.292 11.874 11.83l.001.045c0 6.054-3.928 11.567-10.423 16.317a2.46 2.46 0 0 1-2.904 0C7.146 26.413 3.239 20.989 3.13 15.034zM15 10.403a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.892,
    cy: 24.698,
    r: 7.8,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC0C1C",
    fillRule: "evenodd",
    d: "M33.08 28.845a7.3 7.3 0 0 0 1.233-4.063A7.32 7.32 0 0 0 27 17.47a7.312 7.312 0 1 0 6.08 11.375m-3.432-5.915-1.852 1.852 1.852 1.852a.564.564 0 0 1-.796.796L27 25.577l-1.852 1.853a.563.563 0 0 1-.796-.796l1.853-1.852-1.853-1.852a.563.563 0 0 1 .796-.796L27 23.987l1.852-1.853a.56.56 0 0 1 .918.183.56.56 0 0 1-.122.613",
    clipRule: "evenodd"
  })));
};
export default SvgLocationError;